document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!form.matches("[data-ajax-cart-form]")) return;

  event.preventDefault();

  const button = form.querySelector("[type='submit']");
  const original = button ? button.textContent : "";

  if (button) {
    button.disabled = true;
    button.textContent = "Adding";
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    });

    if (!response.ok) throw new Error("Cart add failed");
    window.location.href = "/cart";
  } catch (error) {
    form.dataset.error = "true";
    if (button) button.textContent = "Try again";
  } finally {
    if (button) {
      button.disabled = false;
      if (button.textContent === "Adding") button.textContent = original;
    }
  }
});

const showPiuToast = () => {
  const toast = document.querySelector(".toast");
  if (!toast) return;
  toast.classList.add("in");
  window.clearTimeout(window.__piuThemeToastTimer);
  window.__piuThemeToastTimer = window.setTimeout(() => toast.classList.remove("in"), 1800);
};

document.addEventListener("click", (event) => {
  const wayButton = event.target.closest(".way[data-way]");
  if (wayButton) {
    const way = wayButton.dataset.way;
    document.querySelectorAll(".way[data-way]").forEach((button) => {
      button.setAttribute("aria-pressed", String(button === wayButton));
    });
    document.querySelectorAll(".card[data-way]").forEach((card) => {
      card.classList.toggle("is-mute", way !== "all" && card.dataset.way !== way);
    });
  }

  if (event.target.closest(".add")) {
    showPiuToast();
  }
});
